import Fuse from 'fuse.js';
import * as THREE from 'three'
import { generateGalaxy } from './components/galaxy/galaxy.js';
import ThreeController from './components/threeSetup/threeSetup.js';
import newSearch from './components/search/newSearch.js';
import CatalogueController from './components/search/CatalogueController.js';
import CartController from './components/cart/CartController.js';
import CarouselComponent from './components/threeMeshes/carousel.js';
// Import the countries.json file
import countriesData from './countries.json';

// Function to populate the country select
function populateCountrySelect(countries) {
    const countrySelect = document.getElementById('country');

    // Iterate over each country in the array
    countries.forEach(country => {
        // Create an option element
        const option = document.createElement('option');
        
        // Set the value and text of the option
        option.value = country.code;
        option.textContent = country.name;

        // Append the option to the select element
        countrySelect.appendChild(option);
    });
}



// Example usage


// Load countries from JSON file


const threeController = new ThreeController();
threeController.createParticles();



// threeController.smokeAnimation();


const catalogueController = new CatalogueController(threeController);


const NewSearch = new newSearch(catalogueController);


const carouselComponent = new CarouselComponent(catalogueController);

function openModal() {
    let modal = document.getElementById("imageViewer");
    modal.style.display = "block";
    // Add a small delay to allow the CSS transition to take effect
    setTimeout(() => {
        modal.style.backgroundColor = "rgba(0,0,0,0.9)"; // Set background color to opaque black
        modal.style.opacity = "1"; // Set opacity to fully opaque
    }, 50); // Adjust the delay as needed
}

// Close the modal with transition
function closeModal() {
    let modal = document.getElementById("imageViewer");
    modal.style.backgroundColor = "rgba(0,0,0,0)"; // Set background color to transparent
    modal.style.opacity = "0"; // Set opacity to fully transparent
    // Add a delay to allow the CSS transition to complete before hiding the modal
    setTimeout(() => {
        modal.style.display = "none";
    }, 300); // Match the transition duration in CSS
}

// Rest of your JavaScript code remains the same...


let slideIndex = 1;

function showSlides(n) {
    let slides = document.getElementsByClassName("about-image");
    if (n > slides.length) {slideIndex = 1}
    if (n < 1) {slideIndex = slides.length}
    document.getElementById("expandedImg").src = slides[slideIndex-1].src;
}

function plusSlides(n) {
    showSlides(slideIndex += n);
}
window.plusSlides = plusSlides;

// generateGalaxy(scene, renderer, clock)

// gui.add(galaxyParameters, 'count').min(100).max(1000000).step(100).onFinishChange(generateGalaxy)
// gui.add(galaxyParameters, 'radius').min(0.01).max(20).step(0.01).onFinishChange(generateGalaxy)
// gui.add(galaxyParameters, 'branches').min(2).max(20).step(1).onFinishChange(generateGalaxy)
// gui.add(galaxyParameters, 'randomness').min(0).max(2).step(0.001).onFinishChange(generateGalaxy)
// gui.add(galaxyParameters, 'randomnessPower').min(1).max(10).step(0.001).onFinishChange(generateGalaxy)
// gui.addColor(galaxyParameters, 'insideColor').onFinishChange(generateGalaxy)
// gui.addColor(galaxyParameters, 'outsideColor').onFinishChange(generateGalaxy)

    
//     const cameraFolder = gui.addFolder('spotLight');
//     cameraFolder.add(camera.position, 'x', -10, 10).name('Camera X');
//     cameraFolder.add(camera.position, 'y', -10, 10).name('Camera Y');
//     cameraFolder.add(camera.position, 'z', -10, 10).name('Camera Z');
//     cameraFolder.add(camera.rotation, 'x', -10, 10).name('Camera RX');
//     cameraFolder.add(camera.rotation, 'y', -10, 10).name('Camera RY');
//     cameraFolder.add(camera.rotation, 'z', -10, 10).name('Camera RZ');
// ///////GALAXY GUI////////////
// const galaxyFolder = gui.addFolder('Galaxy');
// const galaxyPosition = {
//     x: 0,
//     y: 0,
//     z: 0,
// };

// const galaxyRotation = {
//     rotationX: 0,
//     rotationY: 0,
//     rotationZ: 0,
// };

// // Position Controls
// galaxyFolder.add(galaxyPosition, 'x', -5, 5).onChange(value => {
//     galaxyPoints.position.x = value;
// });
// galaxyFolder.add(galaxyPosition, 'y', -5, 5).onChange(value => {
//     galaxyPoints.position.y = value;
// });
// galaxyFolder.add(galaxyPosition, 'z', -5, 5).onChange(value => {
//     galaxyPoints.position.z = value;
// });

// // Rotation Controls
// galaxyFolder.add(galaxyRotation, 'rotationX', -Math.PI, Math.PI).onChange(value => {
//     galaxyPoints.rotation.x = value;
// });
// galaxyFolder.add(galaxyRotation, 'rotationY', -Math.PI, Math.PI).onChange(value => {
//     galaxyPoints.rotation.y = value;
// });
// galaxyFolder.add(galaxyRotation, 'rotationZ', -Math.PI, Math.PI).onChange(value => {
//     galaxyPoints.rotation.z = value;
// });

// galaxyFolder.open();
//////////////////



// generateGalaxy()
// galaxyPoints.rotation.x = galaxyRotation.rotationX;
// galaxyPoints.rotation.y = galaxyRotation.rotationY;
// galaxyPoints.rotation.z = galaxyRotation.rotationZ;


/**
 * Animate
 */

///////////////////////////DOMS//////////////////////
///////////////////////////DOMS//////////////////////
///////////////////////////DOMS//////////////////////
///////////////////////////DOMS//////////////////////



document.addEventListener('DOMContentLoaded', function() {
    const language = getCookie('language') || 'eng';
    loadTranslations(language);
    // Set language cookie when language is selected
    document.querySelector('a[href="?language=eng"]').addEventListener('click', () => {
        document.cookie = "language=eng; path=/";
        loadTranslations('eng');
    });
    document.querySelector('a[href="?language=gr"]').addEventListener('click', () => {
        document.cookie = "language=gr; path=/";
        loadTranslations('gr');
    });
    document.getElementById('floatingCartBtn').addEventListener('click', () => {
    navigateToSection('cart');
});
    function loadTranslations(language) {
        fetch(`/assets/translations-${language}.json`)
            .then(response => response.json())
            .then(translations => {
            try {
            // Null-safe helper used throughout — all querySelector calls go via _qs or _t
            const _qs = (sel, val, prop) => {
                const el = document.querySelector(sel);
                if (el && val !== undefined) el[prop || 'textContent'] = val;
            };

            // ── Nav links ─────────────────────────────────────────────────────
            _qs('a[href="#home"]',      translations.home);
            _qs('a[href="#catalogue"]', translations.catalogue);
            _qs('a[href="#perfumer"]',  translations.perfumer);
            _qs('a[href="#about"]',     translations.about);
            _qs('a[href="#contact"]',   translations.contact);
            const cartTextEl = document.querySelector('#floatingCartBtn .cart-label');
            if (cartTextEl) cartTextEl.textContent = translations.cart;

            // ── Home section ──────────────────────────────────────────────────
            _qs('#center-panel h1',  translations.original_creations);
            _qs('#center-panel h2',  translations.discover_perfumes);
            _qs('#center-panelC h1',  translations.contact_us);
            _qs('#center-panelC h2',  translations.parosb_hours);
            _qs('#center-panelC h3',  translations.working_hours);
            _qs('#left-panel h2',    translations.new_catalogue);
            _qs('#left-panel p',     translations.discover_essence);
            _qs('#left-panel a',     translations.go_there_now);
            _qs('#right-panel h2',   translations.try_perfumer);
            _qs('#right-panel p',    translations.embark_journey);
            _qs('#right-panel a',    translations.to_the_perfumer);

            // ── Contact section — now handled by _t() below with correct IDs ──
            // (old direct querySelector calls removed — they used wrong keys
            //  and would throw TypeError if elements were null)

            // ── Cart section — null-safe ──────────────────────────────────────
            // NOTE: #cartItems is intentionally NOT translated — it contains
            // rendered HTML cart cards that must never be wiped by textContent.
            _qs('#cart h2',                   translations.your_cart);
            _qs('#cartTotal',                 translations.total);
            _qs('#chcktBtn',                  translations.checkout);
            _qs('#paymentMethodMessage p',    translations.payment_method);
            _qs('#bankTransferBtn',           translations.bank_transfer);
            _qs('#cardPaymentBtn',            translations.card_payment);
            _qs('#shippingCost',              translations.shipping_cost);
            _qs('#finalCost',                 translations.total_cost);

            // ── Make translations available to CatalogueController ────────────
            window.catalogueTranslations = translations;

            // Update text content for catalogue sidebar (new .csb-btn selectors)
            const _t = (sel, val, useHTML) => {
                const el = document.querySelector(sel);
                if (el && val) { if (useHTML) el.innerHTML = val; else el.textContent = val; }
            };
            _t('.csb-btn[data-gender="men"]',         translations.men_perfumes);
            _t('.csb-btn[data-gender="women"]',       translations.women_perfumes);
            _t('.csb-btn[data-gender="unisex"]',      translations.unisex_perfumes);
            _t('.csb-btn[data-category="candles"]',   translations.aromatic_candles);
            _t('.csb-btn[data-category="cstBody"]',   translations.customized_body);
            _t('.csb-btn[data-category="oliBody"]',   translations.olivaloe_body);
            _t('.csb-btn[data-category="carrier"]',   translations.carrier_oils);
            _t('.csb-btn[data-category="essential"]', translations.essential_oils);
            _t('.csb-btn[data-category="autFreshers"]',translations.auto_freshers);
            _t('.csb-btn[data-category="intFreshers"]',translations.interior_freshers);
            _t('.csb-btn[data-category="moistSkcare"]',translations.moisturizer_skin);
            _t('.csb-btn[data-category="soapanti"]',  translations.soaps_antiseptics);
            _t('.csb-btn[data-category="colognes"]',  translations.colognes);

            // ── Catalogue empty states ──────────────────────────────────────
            _t('#cleText',       translations.select_category_prompt_html, true);
            _t('#cdpEmptyText',  translations.select_product_prompt_html,  true);
            _t('#cdpFragLabel',  translations.fragrance_notes);
            _t('#cdpPriceLabel', translations.price);
            _t('#cdpFreeSample', translations.free_sample);
            _t('#cssNotesLabel', translations.notes);
            _t('#noteText', translations.catalogue_note);
            _t('#csb-label-perfumes', translations.perfumes_label);
            _t('#csb-label-daily',    translations.daily_care_products);
            // ── Perfumer section ────────────────────────────────────────────
            _t('#perfSelectCat',  translations.perf_select_cat);
            _t('#perfChoiceLbl',  translations.perf_choose_pref);
            _t('#backBtn1',       translations.back);
            _t('#backBtn2',       translations.back);
            _t('#srcBtn',         translations.search);
            if(document.getElementById('searchInputEl'))
                document.getElementById('searchInputEl').placeholder = translations.search_placeholder;

            // ── Cart / Samples ──────────────────────────────────────────────
            _t('#freeSamplesTitle', translations.free_samples);
            _t('#youCanChooseTxt',  translations.you_can_choose);
            _t('#samplesTxt',       translations.samples_txt);
            _t('#remainingTxt',     translations.remaining);
            _t('#addSampleTxt',     translations.add_sample);
            _t('#payMethodTxt',     translations.pay_method);

            // ── Payment form ────────────────────────────────────────────────
            _t('#pfTitle',     translations.pf_title);
            _t('#pfSubtitle',  translations.pf_subtitle);
            _t('#pfSumOrder',  translations.pf_order);
            _t('#pfSumShipping',translations.pf_shipping);
            _t('#pfSumTotal',  translations.pf_total_due);
            _t('#pfDivContact',translations.pf_contact);
            _t('#pfDivBilling',translations.pf_billing);
            _t('#pfLblEmail',  translations.pf_email);
            _t('#pfLblPhone',  translations.pf_phone);
            _t('#pfLblFirst',  translations.pf_first_name);
            _t('#pfLblLast',   translations.pf_last_name);
            _t('#pfLblCountry',translations.pf_country);
            _t('#pfLblState',  translations.pf_state);
            _t('#pfLblCity',   translations.pf_city);
            _t('#pfLblZip',    translations.pf_zip);
            _t('#pfLblStreet', translations.pf_street);
            _t('#pfTermsText', translations.pf_terms);
            _t('#pfSubmitTxt', translations.pf_submit);
            if(document.getElementById('payerEmail'))
                document.getElementById('payerEmail').placeholder = translations.pf_email_ph;

            // ── Home search bar buttons ──────────────────────────────────────
            _t('#mainSearchByName',  translations.search_by_name);
            _t('#mainSearchByNotes', translations.search_by_notes);
            _t('#learnMoreBtn',      translations.learn_more);
            _t('#searchNameBtn2',    translations.search_by_name);
            _t('#searchNotesBtn2',   translations.search_by_notes);

            // ── Perfumer category buttons ────────────────────────────────────
            _t('#perfBtnMen',    translations.perf_men);
            _t('#perfBtnWomen',  translations.perf_women);
            _t('#perfBtnUnisex', translations.perf_unisex);

            // ── Contact page ─────────────────────────────────────────────────
            _t('#contactIntro',    translations.contact_intro);
            _t('#syrosHours',      translations.syros_hours,   true);
            _t('#parosIslandTitle',translations.paros_island);
            _t('#syrosIslandTitle',translations.syros_island);
            _t('#parosAddress',    translations.paros_address, true);
            _t('#syrosAddress',    translations.syros_address, true);

            // ── Samples gender filter ────────────────────────────────────────
            _t('#samplesFilterAll',    translations.all);
            _t('#samplesFilterMen',    translations.men);
            _t('#samplesFilterWomen',  translations.women);
            _t('#samplesFilterUnisex', translations.unisex);

            // ── Footer ───────────────────────────────────────────────────────
            _t('#footerText', translations.footer_text);

            // ── Contact section ──────────────────────────────────────────────
            _t('#contactUsTitle',   translations.contact_us);
            _t('#parosHoursTitle',  translations.paros_hours_title);
            _t('#syrosHoursTitle',  translations.syros_hours_title);
            _t('#cfLblName',        translations.cf_name);
            _t('#cfLblEmail',       translations.cf_email);
            _t('#cfLblMessage',     translations.cf_message);
            _t('#cfSubmitBtn',      translations.cf_submit);
            _t('#cfThankyou',       translations.cf_thankyou);
            _t('#cfBack',           translations.cf_back);

            // ── About section — moved inside try-catch with null checks ──────
            _qs('#about h3:nth-of-type(1)', translations.join_story);
            _qs('#about p:nth-of-type(1)',  translations.scented_story);
            _qs('#about h2',                translations.about_us);
            _qs('#about p:nth-of-type(2)',  translations.our_passion);
            _qs('#about h3:nth-of-type(2)', translations.our_craft);
            _qs('#about p:nth-of-type(3)',  translations.our_craft_text);
            _qs('#about h3:nth-of-type(3)', translations.essence_nature);
            _qs('#about p:nth-of-type(4)',  translations.essence_nature_text);

            } catch(e) {
                console.warn('Translation error (non-fatal):', e.message);
            }

            })
            .catch(error => console.error('Error loading translations:', error));
    }

    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }
    populateCountrySelect(countriesData);
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('status') === 'success') {
        document.getElementById('paymentSuccess').classList.remove('hidden');
        document.getElementById('orderId').textContent = urlParams.get('orderId');
        document.getElementById('orderDesc').textContent = urlParams.get('orderDesc');
        document.getElementById('orderAmount').textContent = urlParams.get('orderAmount');
        document.getElementById('payerEmail').textContent = urlParams.get('payerEmail');
    }
    navigateToSection('home');
    const navLinks = document.querySelectorAll('.nav-menu a');
    const panelLinks = document.querySelectorAll('.background-panel a');

    navLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            const sectionId = e.currentTarget.getAttribute('href').slice(1); // Get the section id from href
            navigateToSection(sectionId);
            e.preventDefault(); // Prevent default anchor link behavior
            
            // ✅ Close burger menu on nav click
            navbar.classList.remove('open');
            menuOverlay.classList.remove('active');
            hamburger.classList.remove('is-active');
        });
    });

    panelLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            const sectionId = e.target.getAttribute('href').slice(1); // Get the section id from href
            navigateToSection(sectionId);
            e.preventDefault(); // Prevent default anchor link behavior
        });
    });
    
    var hamburger = document.querySelector('.hamburger');
    var navbar = document.querySelector('.navbar');
    var menuOverlay = document.createElement('div');
    menuOverlay.classList.add('menu-overlay');
    document.body.appendChild(menuOverlay);

    hamburger.addEventListener('click', function() {
        navbar.classList.toggle('open');
        menuOverlay.classList.toggle('active');
        this.classList.toggle('is-active');
    });

    menuOverlay.addEventListener('click', function() {
        navbar.classList.remove('open');
        menuOverlay.classList.remove('active');
        hamburger.classList.remove('is-active');
    });
    let images = document.getElementsByClassName("about-image");
    for (let i = 0; i < images.length; i++) {
        images[i].addEventListener('click', function() {
            document.getElementById("expandedImg").src = this.src;
            openModal();
            showSlides(slideIndex);
        });
    }

    document.getElementsByClassName("closeThis")[0].addEventListener('click', function() {
        closeModal();
    });

    

    const form = document.getElementById('contactForm');
    const thankYouMessage = document.getElementById('thankYouMessage');
    const formBack = document.getElementById('formBack');

    form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const formData = new FormData(form);

        fetch('./contact.php', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === 'success') {
                alert(data.message);
                form.style.display = 'none';
                thankYouMessage.style.display = 'block';
            } else {
                alert(data.message);
            }
        })
        .catch(error => {
            console.error('Error:', error);
            alert('There was a problem submitting your form. Please try again later.');
        });
    });

    formBack.addEventListener('click', function() {
        form.style.display = 'block';
        thankYouMessage.style.display = 'none';
        form.reset();
    });


    
});


/////////////////////////////////SEARCHER//////////////////////////



// Attach the resetSearch function to the window object
// Attach the functions to the window object


////////////NAVIGATE TO SECTIONS//////////////////
function navigateToSection(sectionId) {
    const currentlyVisibleSection = document.querySelector('.section.visible');
    const sectionToShow = document.getElementById(sectionId);
    
    if (threeController.perfumeBottle) {
        threeController.removeCurrentPerfumeBottle();
    }


    const perfumePopup = document.querySelector('.perfume-popup');
    if (perfumePopup) {
        perfumePopup.style.display = 'none';
    }

    // Check if the product-popup element is visible and hide it if it is
    const productPopup = document.querySelector('.product-popup');
    if (productPopup) {
        productPopup.style.display = 'none';
    }



    // Start the section fade-out immediately
    if (currentlyVisibleSection && currentlyVisibleSection.id !== sectionId) {
        currentlyVisibleSection.style.opacity = '0';
        currentlyVisibleSection.addEventListener('transitionend', function transitionOut() {
            this.classList.remove('visible');
            this.removeEventListener('transitionend', transitionOut);

            // Make particles invisible after the section is hidden
            threeController.particles.models.forEach(model => model.visible = false);

            // Show the new section
            showNewSection(sectionToShow);
        }, { once: true });
    } else if (sectionToShow && !currentlyVisibleSection) {
        // If there is no currently visible section, just show the new section
        showNewSection(sectionToShow);
    }

    // Make particles visible and play the animation
    threeController.particles.models.forEach(model => model.visible = true);
    threeController.particles.smokeAnimation();
    
    // Set a timeout to hide the particles after the animation plays
    setTimeout(() => {
        threeController.particles.models.forEach(model => model.visible = false);
    }, 1000); // Adjust based on the duration of your smokeAnimation
}


function showNewSection(sectionToShow) {
    if (sectionToShow) {
        // Ensure the display change is acknowledged before adjusting opacity
        requestAnimationFrame(() => {
            sectionToShow.style.opacity = '1';
            sectionToShow.classList.add('visible');

            // Show the note after a delay of 1 second
            setTimeout(() => {
                document.getElementById('note').style.display = 'block';
            }, 1000);
        });
    }
}


function closeNote() {
    document.getElementById('note').style.display = 'none';
}

window.navigateToSection = navigateToSection;
window.closeNote = closeNote;










//////////FILTER GENDER AND ACIDITY////////////////




//////////////////LOGIN START JAVASCRIPT MOCKED/////////////////

// function handleLogin(event) {
//     event.preventDefault();
    
//     const username = document.getElementById('username').value;
//     const password = document.getElementById('password').value;

//     // This is where you would send a request to your backend
//     // For now, we'll just mock this
//     const users = {
//         'jarjarA': 'obiwanTwo',
//         'jarjarB': 'obiwanThree'
//     };

//     if (users[username] === password) {
//         // Login successful
//         console.log('Login successful');
//         sessionStorage.setItem('isLoggedIn', 'true');
//         // Redirect to a new page or change the UI to reflect the logged-in status
//         window.location.href = '/dashboard'; // Mock redirect to a dashboard
        
//         alert('Welcome');
//     } else {
//         // Login failed
//         console.log('Login failed');
//         alert('Invalid username or password');
//     }
// }

// // Example logout function
// function handleLogout() {
//     sessionStorage.removeItem('isLoggedIn');
//     // Redirect to the homepage or change the UI to reflect the logged-out status
//     window.location.href = '/';
// }

// // Check if the user is logged in and update UI accordingly
// function checkLoginStatus() {
//     const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
//     // Update UI based on login status
// }

// // Call this function on page load and after login/logout
// checkLoginStatus();